import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { IStandSettings } from "@/models/StandSettings";

export interface StandState {
  standSettings: IStandSettings | null;
  editSettingsLoading: boolean;
  editSettingsError: string;
}

const initialState: StandState = {
  standSettings: null,
  editSettingsLoading: false,
  editSettingsError: "",
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setStandSettings: (state, action: PayloadAction<IStandSettings>) => {
      state.standSettings = action.payload;
    },
    setEditSettingsLoading: (state, action: PayloadAction<boolean>) => {
      state.editSettingsLoading = action.payload;
    },
    setEditSettingsError: (state, action: PayloadAction<string>) => {
      state.editSettingsError = action.payload;
    },
    reset: () => initialState,
  },
});

export const {
  setStandSettings,
  setEditSettingsLoading,
  setEditSettingsError,
  reset: resetSettingsState,
} = settingsSlice.actions;

export default settingsSlice.reducer;
